// Command Parser - 命令解析器
import { CommandManager } from './CommandManager.js';
import { registerAllCommands } from '../commands/index.js';
import { registerForbiddenCommands } from '../commands/forbidden.js';
import { UtilsManager } from '../utils/index.js';
import { COMMAND_MAPPINGS, getEnglishCommand } from '../config/commands.js';

class CommandParser {
  constructor(stateManager, explorationManager, forbiddenManager) {
    this.stateManager = stateManager;
    this.explorationManager = explorationManager;
    this.forbiddenManager = forbiddenManager;

    // 创建指令管理器
    this.commandManager = new CommandManager(
      stateManager,
      explorationManager,
      forbiddenManager
    );

    // 注册所有指令
    this.registerCommands();
  }

  // 注册所有指令
  registerCommands() {
    registerAllCommands(this.commandManager);
    registerForbiddenCommands(this.commandManager);
  }

  // 解析命令
  parseCommand(input) {
    const validation = UtilsManager.validateCommand(input);
    if (!validation.valid) {
      return [validation.error];
    }

    // 检查是否需要起名
    const args = UtilsManager.parseCommandArgs(input);
    let cmd = args[0].toLowerCase();

    // 使用配置中的中文命令映射
    cmd = getEnglishCommand(cmd);

    if (!this.stateManager.isNamed() && cmd !== 'name' && cmd !== 'help') {
      return ['请先使用 `name <名字>` 进行起名，例如：name 少侠。'];
    }

    // 检查是否在禁地模式
    if (this.stateManager.isInForbiddenMap()) {
      const allowedCommands = ['up', 'down', 'left', 'right', 'scan', 'exit', 'status', 'help'];
      if (allowedCommands.indexOf(cmd) === -1) {
        return ['你在禁地中，只能使用：up, down, left, right, scan, exit, status, help'];
      }
    }

    // 使用指令管理器执行命令（传递处理后的命令）
    const processedInput = input.replace(/^\w+/, cmd);
    const result = this.commandManager.executeCommand(processedInput);

    // 自动保存
    if (this.commandManager.shouldAutoSave(cmd)) {
      this.stateManager.saveState();
    }

    return result;
  }



  // 获取建议
  getSuggestions(input) {
    return this.commandManager.getSuggestions(input);
  }
}

export default CommandParser;
